import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["MeasuringPointGroup"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMeasuringPointGroup: build.query<
        GetMeasuringPointGroupApiResponse,
        GetMeasuringPointGroupApiArg
      >({
        query: () => ({ url: `/MeasuringPointGroup` }),
        providesTags: ["MeasuringPointGroup"],
      }),
      postMeasuringPointGroup: build.mutation<
        PostMeasuringPointGroupApiResponse,
        PostMeasuringPointGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPointGroup`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["MeasuringPointGroup"],
      }),
      putMeasuringPointGroupById: build.mutation<
        PutMeasuringPointGroupByIdApiResponse,
        PutMeasuringPointGroupByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPointGroup/${queryArg.id}`,
          method: "PUT",
          body: queryArg.measuringPointGroupDto,
        }),
        invalidatesTags: ["MeasuringPointGroup"],
      }),
      deleteMeasuringPointGroupById: build.mutation<
        DeleteMeasuringPointGroupByIdApiResponse,
        DeleteMeasuringPointGroupByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPointGroup/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["MeasuringPointGroup"],
      }),
      getMeasuringPointGroupAssignment: build.query<
        GetMeasuringPointGroupAssignmentApiResponse,
        GetMeasuringPointGroupAssignmentApiArg
      >({
        query: () => ({ url: `/MeasuringPointGroup/Assignment` }),
        providesTags: ["MeasuringPointGroup"],
      }),
      getMeasuringPointGroupAssignmentByGroupAssignment: build.query<
        GetMeasuringPointGroupAssignmentByGroupAssignmentApiResponse,
        GetMeasuringPointGroupAssignmentByGroupAssignmentApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPointGroup/Assignment/${queryArg}/Assignment`,
        }),
        providesTags: ["MeasuringPointGroup"],
      }),
      putMeasuringPointGroupAssignmentByGroupAndMeasuringPoint: build.mutation<
        PutMeasuringPointGroupAssignmentByGroupAndMeasuringPointApiResponse,
        PutMeasuringPointGroupAssignmentByGroupAndMeasuringPointApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPointGroup/Assignment/${queryArg.group}/${queryArg.measuringPoint}`,
          method: "PUT",
        }),
        invalidatesTags: ["MeasuringPointGroup"],
      }),
      deleteMeasuringPointGroupAssignmentByGroupAndMeasuringPoint:
        build.mutation<
          DeleteMeasuringPointGroupAssignmentByGroupAndMeasuringPointApiResponse,
          DeleteMeasuringPointGroupAssignmentByGroupAndMeasuringPointApiArg
        >({
          query: (queryArg) => ({
            url: `/MeasuringPointGroup/Assignment/${queryArg.group}/${queryArg.measuringPoint}`,
            method: "DELETE",
          }),
          invalidatesTags: ["MeasuringPointGroup"],
        }),
      getMeasuringPointGroupType: build.query<
        GetMeasuringPointGroupTypeApiResponse,
        GetMeasuringPointGroupTypeApiArg
      >({
        query: () => ({ url: `/MeasuringPointGroup/Type` }),
        providesTags: ["MeasuringPointGroup"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measuringPointGroupApi };
export type GetMeasuringPointGroupApiResponse =
  /** status 200 OK */ MeasuringPointGroupDto[];
export type GetMeasuringPointGroupApiArg = void;
export type PostMeasuringPointGroupApiResponse = /** status 201 Created */ void;
export type PostMeasuringPointGroupApiArg = MeasuringPointGroupDto;
export type PutMeasuringPointGroupByIdApiResponse = /** status 200 OK */ void;
export type PutMeasuringPointGroupByIdApiArg = {
  id: number;
  measuringPointGroupDto: MeasuringPointGroupDto;
};
export type DeleteMeasuringPointGroupByIdApiResponse = unknown;
export type DeleteMeasuringPointGroupByIdApiArg = number;
export type GetMeasuringPointGroupAssignmentApiResponse =
  /** status 200 OK */ MeasuringPointGroupAssignmentDto[];
export type GetMeasuringPointGroupAssignmentApiArg = void;
export type GetMeasuringPointGroupAssignmentByGroupAssignmentApiResponse =
  /** status 200 OK */ MeasuringPointDto[];
export type GetMeasuringPointGroupAssignmentByGroupAssignmentApiArg = number;
export type PutMeasuringPointGroupAssignmentByGroupAndMeasuringPointApiResponse =
  unknown;
export type PutMeasuringPointGroupAssignmentByGroupAndMeasuringPointApiArg = {
  group: number;
  measuringPoint: string;
};
export type DeleteMeasuringPointGroupAssignmentByGroupAndMeasuringPointApiResponse =
  unknown;
export type DeleteMeasuringPointGroupAssignmentByGroupAndMeasuringPointApiArg =
  {
    group: number;
    measuringPoint: string;
  };
export type GetMeasuringPointGroupTypeApiResponse =
  /** status 200 OK */ MeasuringPointGroupTypeDto[];
export type GetMeasuringPointGroupTypeApiArg = void;
export type MeasuringPointGroupDto = {
  id: number;
  name: string;
  type: number;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type MeasuringPointGroupAssignmentDto = {
  measuringPointGroup: number;
  measuringPointGroupName: string;
  measuringPoint: string;
  voltageLevel: string;
};
export type MeasuringPointDto = {
  name: string;
  latitude?: number;
  longitude?: number;
  switchgear: string;
  voltageLevel: string;
  currentTransformer: string;
  voltageTransformer: string;
  substation: string;
  comment?: string | null;
  hasData: boolean;
  isUsed: boolean;
  wasEverUsed: boolean;
  transformerModelVoltageL1?: number | null;
  transformerModelVoltageL2?: number | null;
  transformerModelVoltageL3?: number | null;
  transformerModelCurrentL1?: number | null;
  transformerModelCurrentL2?: number | null;
  transformerModelCurrentL3?: number | null;
};
export type MeasuringPointGroupTypeDto = {
  id: number;
  name: string;
};
export const {
  useGetMeasuringPointGroupQuery,
  useLazyGetMeasuringPointGroupQuery,
  usePostMeasuringPointGroupMutation,
  usePutMeasuringPointGroupByIdMutation,
  useDeleteMeasuringPointGroupByIdMutation,
  useGetMeasuringPointGroupAssignmentQuery,
  useLazyGetMeasuringPointGroupAssignmentQuery,
  useGetMeasuringPointGroupAssignmentByGroupAssignmentQuery,
  useLazyGetMeasuringPointGroupAssignmentByGroupAssignmentQuery,
  usePutMeasuringPointGroupAssignmentByGroupAndMeasuringPointMutation,
  useDeleteMeasuringPointGroupAssignmentByGroupAndMeasuringPointMutation,
  useGetMeasuringPointGroupTypeQuery,
  useLazyGetMeasuringPointGroupTypeQuery,
} = injectedRtkApi;
